import { Card, CardContent, CardTitle } from '@/components/ui/Card.tsx';
import { Check } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';

interface WaitlistSuccessCardProps {
  tourName: string;
  position: number;
}

const WaitlistSuccessCard = ({
  tourName,
  position,
}: WaitlistSuccessCardProps) => {
  return (
    <div className="mx-auto flex min-h-[60vh] items-center justify-center">
      <Card className="w-full max-w-[600px]">
        <CardContent className="space-y-4 py-6">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-md bg-success-100">
            <Check className="size-10 text-success-300" />
          </div>
          <CardTitle className="text-center text-3xl font-semibold leading-snug text-base-text">
            Zapisano na listę rezerwową
          </CardTitle>
          <div className="space-y-2 text-center text-sm text-neutral-600">
            <p>
              Zostałeś zapisany na listę rezerwową na wyjazd
              <br />
              <span className="font-semibold text-base-text">{tourName}</span>
            </p>
            <p>
              Twoja pozycja na liście:{' '}
              <span className="font-semibold text-base-text">{position}</span>
            </p>
            <p className="mt-4">
              Skontaktujemy się z Tobą, gdy zwolni się miejsce.
            </p>
          </div>

          <div className="flex justify-center">
            <ActionButton
              tone="accent"
              size="sm"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Powrót do strony głównej
            </ActionButton>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default WaitlistSuccessCard;
